import { useCallback, useState } from 'react'

export default function useNotification() {
  const [notification, setNotification] = useState({ open: false, message: '', type: 'info', label: '' })

  const showNotification = useCallback((message, type = 'info', label = '') => {
    setNotification({ open: true, message, type, label })
  }, [])

  const closeNotification = useCallback(() => {
    setNotification((prev) => ({ ...prev, open: false }))
  }, [])

  return {
    showNotification,
    closeNotification,
    notificationProps: {
      open: notification.open,
      onClose: closeNotification,
      message: notification.message,
      label: notification.label,
      type: notification.type,
    },
  }
}
